var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup"
    },
    [
      _c(
        "div",
        { staticClass: "lite_popup_box" },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loadingVersions,
                expression: "loadingVersions"
              }
            ],
            staticClass: "lite-version-loading"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "lite_popup_title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.cloudBackup.restore")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lite_popup_content" },
            [
              _c("div", { staticClass: "select-desc" }, [
                _vm._v(_vm._s(_vm.$t("language.cloudBackup.selectVersions")))
              ]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "down_menu_items",
                  attrs: {
                    "popper-class": "down_menu_item",
                    size: "small",
                    placeholder: " "
                  },
                  model: {
                    value: _vm.version,
                    callback: function($$v) {
                      _vm.version = $$v
                    },
                    expression: "version"
                  }
                },
                _vm._l(_vm.versions, function(version) {
                  return _c("el-option", {
                    key: version,
                    attrs: {
                      label: _vm.formatDate(version),
                      value: version + ""
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.version
                ? _c(
                    "span",
                    {
                      staticClass: "lite_backup_version_details",
                      on: {
                        click: function($event) {
                          return _vm.loadVersionInfo(true)
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "lite_backup_version_details_icon"
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("language.imageSaver.view")))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "select-desc" }, [
                _vm._v(_vm._s(_vm.$t("language.cloudBackup.restoreOptions")))
              ]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "down_menu_items",
                  attrs: {
                    "popper-class": "down_menu_item",
                    size: "small",
                    placeholder: " "
                  },
                  model: {
                    value: _vm.sameName,
                    callback: function($$v) {
                      _vm.sameName = $$v
                    },
                    expression: "sameName"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("language.cloudBackup.keepLatest"),
                      value: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("language.popup.overWrite"),
                      value: "overwrite"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("language.popup.skipFile"),
                      value: "skip"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("language.popup.rename"),
                      value: "rename"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  staticClass: "restore-location",
                  model: {
                    value: _vm.restoreLocation,
                    callback: function($$v) {
                      _vm.restoreLocation = $$v
                    },
                    expression: "restoreLocation"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "old" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.cloudBackup.restoreOriginal"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.data
                ? _c(
                    "div",
                    { staticClass: "restore_tree_box myscroll" },
                    [
                      _c("el-tree", {
                        staticClass: "restore_tree",
                        attrs: {
                          data: _vm.convertData(),
                          "default-expand-all": true
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var node = ref.node
                                var data = ref.data
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node2" },
                                  [
                                    node.level == 1
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              "drive-icon2 drive-icon-" +
                                              data.icon
                                          },
                                          [_vm._v(_vm._s(data.label))]
                                        )
                                      : _c("span", [
                                          _c("img", {
                                            staticClass: "node-icon2",
                                            attrs: {
                                              src:
                                                "/static/file/" +
                                                data.icon +
                                                ".svg"
                                            },
                                            on: {
                                              error: function(e) {
                                                return (e.target.src =
                                                  "/static/file/file.svg")
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "node-name-label2" },
                                            [_vm._v(_vm._s(data.label))]
                                          )
                                        ])
                                  ]
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          2970427369
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  staticClass: "restore-location",
                  model: {
                    value: _vm.restoreLocation,
                    callback: function($$v) {
                      _vm.restoreLocation = $$v
                    },
                    expression: "restoreLocation"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "new" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.cloudBackup.restoreNewLocation"))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.newLocationDid
                ? _c(
                    "div",
                    { staticClass: "restore_tree_box myscroll" },
                    [
                      _c("el-tree", {
                        staticClass: "restore_tree",
                        attrs: {
                          data: _vm.convertSelect(),
                          "default-expand-all": true
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var node = ref.node
                                var data = ref.data
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node2" },
                                  [
                                    node.level == 1
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              "drive-icon2 drive-icon-" +
                                              data.icon
                                          },
                                          [_vm._v(_vm._s(data.label))]
                                        )
                                      : _c("span", [
                                          _c("img", {
                                            staticClass: "node-icon2",
                                            attrs: {
                                              src:
                                                "/static/file/" +
                                                data.icon +
                                                ".svg"
                                            },
                                            on: {
                                              error: function(e) {
                                                return (e.target.src =
                                                  "/static/file/file.svg")
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "node-name-label2" },
                                            [_vm._v(_vm._s(data.label))]
                                          )
                                        ])
                                  ]
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          2970427369
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.restoreSelect.froms.length > 0 &&
              _vm.restoreSelect.tos.length > 0
                ? _c("div", { staticClass: "restore_select_list_box" }, [
                    _c("div", {
                      staticClass: "restore_select_edit",
                      on: {
                        click: function($event) {
                          return _vm.selectTaskTo()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "restore_select_row" }, [
                      _c("div", { staticClass: "restore_select_left head" }, [
                        _vm._v(_vm._s(_vm.$t("language.website.sourceServers")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "restore_select_right head" }, [
                        _vm._v(_vm._s(_vm.$t("language.website.targetServers")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "restore_select_row myscroll" }, [
                      _c(
                        "div",
                        { staticClass: "restore_select_left" },
                        _vm._l(_vm.restoreSelect.froms, function(item) {
                          return _c(
                            "div",
                            { staticClass: "restore_select_item" },
                            [
                              _c("div", {
                                staticClass: "restore_select_item_icon",
                                class: item.node.type
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "restore_select_item_text" },
                                [_vm._v(_vm._s(item.node.name))]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "restore_select_item_bg"
                              })
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "restore_select_right" },
                        _vm._l(_vm.restoreSelect.tos, function(item) {
                          return _c(
                            "div",
                            { staticClass: "restore_select_item" },
                            [
                              _c("div", {
                                staticClass: "restore_select_item_icon",
                                class: item.node.type
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "restore_select_item_text" },
                                [_vm._v(_vm._s(item.node.name))]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "restore_select_item_bg"
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "lite_popup_footer" }, [
            _c(
              "button",
              {
                staticClass: "white",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
            ),
            _vm._v(" "),
            _vm.version &&
            _vm.restoreLocation == "new" &&
            !_vm.newLocationDid &&
            _vm.restoreSelect.froms.length == 0
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.selectTaskTo()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.setUp")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.version &&
            (_vm.restoreLocation == "old" ||
              (_vm.restoreLocation == "new" &&
                (_vm.newLocationDid || _vm.restoreSelect.froms.length > 0)))
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.ok()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.cloudBackup.restore")))]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("liteSelect", {
            ref: "taskToTree",
            attrs: {
              showCheckbox: false,
              showDBDrive: false,
              showEmailDrive: false,
              showFileNode: false,
              showNewFolder: true
            },
            on: { selectDone: _vm.selectDoneTo }
          }),
          _vm._v(" "),
          _c("liteSelect", {
            ref: "taskToTreeWebsite",
            attrs: {
              onlyWebsite: true,
              showWebsite: true,
              showCheckbox: false,
              showDBDrive: false,
              showEmailDrive: false,
              showFileNode: false,
              showNewFolder: true
            },
            on: { selectDone: _vm.selectDoneTo }
          }),
          _vm._v(" "),
          _c("liteBackupFiles", {
            ref: "backupFiles",
            attrs: { files: _vm.versionFiles }
          }),
          _vm._v(" "),
          _c("liteWebsiteRestoreSelect", {
            ref: "websiteRestoreSelect",
            attrs: { data: _vm.restoreParam, versionFiles: _vm.versionFiles },
            on: { ok: _vm.websiteRestoreSelectDone }
          }),
          _vm._v(" "),
          _c("liteConfirmMysql", {
            ref: "liteConfirmMysql",
            attrs: { type: "restore" },
            on: { ok: _vm.mysqlOK, cancel: _vm.mysqlCancel }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9735bc72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9735bc72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_restore.vue
// module id = null
// module chunks = 